import React from 'react'

export default function VeidtPage() {
  return (
    <div>VeidtPage</div>
  )
}
